import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-wrap',
    tabs: 'mb-2 w-full gap-1',
    tab: 'h-10 px-[43px] py-2 normal-case',
    tabsWrap:
      'bg-bg-items-white flex cursor-grab justify-between p-1 max-md:w-fit',
    additionalTab:
      'heading-m text-secondary-hover hover:text-main hover:border-main border-secondary-hover min-w-44 shrink-0 grow cursor-pointer border-b p-3 whitespace-nowrap transition-colors',
    header:
      'bg-bg-items-white flex cursor-pointer px-5 py-4 normal-case select-none',
    headerIcon: 'ml-auto',
    wrapper: '',
    content: 'w-full'
  },
  variants: {
    color: {
      primary: 'text-black'
    },
    view: {
      tab: {
        header: 'hidden',
        wrapper: 'order-2 !max-h-max',
        tabsWrap: 'rounded-full'
      },
      additionalTab: {
        header: 'hidden',
        tabs: 'gap-4 bg-white',
        wrapper: 'order-2 !max-h-max'
      },
      accordion: {
        tabs: 'hidden',
        header: 'mb-5 w-full',
        content: 'pb-5'
      },
      auto: {
        tabs: 'bg-bg-items-white hidden rounded-full md:flex',
        header: 'w-full max-md:mb-1 md:hidden',
        content: 'max-md:pb-5',
        wrapper: 'md:order-2 md:!max-h-max'
      }
    },
    active: {
      true: {},
      false: {}
    }
  },
  compoundVariants: [
    {
      view: 'tab',
      active: false,
      className: {
        content: 'hidden'
      }
    },
    {
      view: 'additionalTab',
      active: false,
      className: {
        content: 'hidden'
      }
    },
    {
      view: 'additionalTab',
      active: true,
      className: {
        additionalTab: 'border-main heading-m-bold text-main border-b-2'
      }
    },
    {
      view: 'auto',
      active: false,
      className: {
        content: 'md:hidden'
      }
    },
    {
      view: 'auto',
      active: true,
      className: {
        wrapper: '!max-h-max'
      }
    },
    {
      view: 'accordion',
      active: true,
      className: {
        wrapper: '!max-h-max'
      }
    }
  ],
  defaultVariants: {
    color: 'primary'
  }
});
